<template>
  <div>
    <div class="dovemed-card">
      <h3
        :style="{
          'text-align': 'left',
          'margin-top': '24px',
          'font-size': '32px',
          'font-weight': '700',
          'font-family': 'Lato',
          color: '#0F1734'
        }"
      >
        Meet Others
      </h3>
     
      <div class="search-container w-100">
        <form
          @submit.prevent="getPeople()"
          class="w-100 d-flex align-items-center searchContainer"
        >
          <font-awesome-icon
            :icon="['fal', 'search']"
            :style="{ color: getPrimaryColor() }"
            @click="getPeople()"
            class="cp pr-3 ml-3"
          />
          <a-input
            type="search"
            class="search-input-state w-100"
            placeholder="Enter Location"
            :value="searchLocation"
            @change="handleSearchChange"
            @input="callDebounce"
            @keyup.enter="handleSearchLocation"
          />
          <a-icon
            v-if="searchLocation"
            class="close-icon mr-3 cp"
            style="width: fit-content;"
            type="close"
            :size="'large'"
            @click="handleClearSearch"
          />
        </form>
        <button @click="handlefilterModal" class="search-button primary-button position-relative">
          <img src="../../assets/lightfilter.svg" alt="Filter icon" />
          <p class="apply">Apply Filters</p>
          <div v-if="searchGender || searchAge || ibs" class="active-filter-indicator" :style="{ background: getPrimaryColor() }" />
        </button>
      </div>

      <div class="filter-container">
        <div class="filter-container2">
          <div class="appliedFilter" v-if="searchAge || ibs || searchGender">
            Applied Filter:
          </div>
          <div v-if="ibs" class="filterTypeBox">
            <div class="filterTypeText">{{ ibs }}</div>
            <i
              class="fa fa-times"
              aria-hidden="true"
              style="cursor: pointer"
              @click="() => clearFilterType('ibs')"
            ></i>
          </div>
          <div v-if="searchAge" class="filterTypeBox">
            <div class="filterTypeText">{{searchAge-9}}-{{searchAge}} year old</div>
            <i
              class="fa fa-times"
              aria-hidden="true"
              style="cursor: pointer"
              @click="() => clearFilterType('age')"
            ></i>
          </div>
          <div v-if="searchGender" class="filterTypeBox">
            <div class="filterTypeText" style="text-transform: capitalize">{{ searchGender }}</div>
            <i
              class="fa fa-times"
              aria-hidden="true"
              style="cursor: pointer"
              @click="() => clearFilterType('gender')"
            ></i>
          </div>
        </div>
        <div class=" clear-filter text-right ">
          <span
            v-if="searchGender || searchAge || ibs"
            :style="{ color: ' #0F1734' }"
            class="ml-5 hyper-link cp"
            @click="clearFilters()"
            >Clear Filters</span
          >
        </div>
      </div>
      <InviteOthersModal />
    </div>
   
    <div>
      

      <div class="doctors-search-result">
        <div id="cards-section-top" class="card-section">
          <p class="text-left  results" v-if="peopleList && !loading">
            <span>{{ count }} Results</span>
          </p>
          <div v-if="peopleList && !loading" class="dropdownOptions text-right  sort-dropdown">
            <a-dropdown
              v-if="peopleList && !loading"
              :trigger="['click']"
              :getPopupContainer="trigger => trigger.parentNode"
              :style="{ marginTop: '7px', cursor: 'pointer' }"
            >
              <p class="sort-text cp">
                Show
                <span style="font-weight: 700;">{{
                  sortKey === "Newest"
                    ? "Newest First"
                    : sortKey === "Oldest"
                    ? "Oldest First"
                    : "Most Popular"
                }}</span>
                <font-awesome-icon
                  size="lg"
                  style="margin-left: 8px;"
                  :icon="['fas', 'angle-down']"
                />
              </p>
              <template #overlay>
                <a-menu @click="e => sortList(e.key)">
                  <a-menu-item key="Newest">Newest First</a-menu-item>
                  <a-menu-item key="Oldest">Oldest First</a-menu-item>
                  <a-menu-item key="Popular">Most Popular</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </div>
        </div>

        <div class="row" v-if="peopleList && !loading">
          <div
            class="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-3"
            v-for="(people, index) in peopleList"
            :key="index"
          >
            <div class="claim-card">
              <div class="user-name d-flex  p-3">
                <a
                  @click="viewProfile(people)"
                  class="bg-img d-block background-image mr-3"
                >
                  <!-- <a-avatar :size="100" :src="people.url" alt="" /> -->
                  <a-avatar
                    :style="{
                      color: ' #ffffff !important',
                      'background-color': people.url
                        ? people.url
                        : ''
                        ? ''
                        : getAvatarColor(people.id)
                    }"
                    :size="70"
                    :src="people.url"
                    class="text-capitalize"
                    alt="profile image"
                  >
                    {{
                      people.firstName
                        ? people.firstName[0]
                        : people.display_name
                        ? people.display_name[0]
                        : people.first_name[0]
                    }}
                  </a-avatar>
                </a>
                <hr class="divider" />
                <div class="right-items  profile-btn">
                  <div
                    class="d-inline-block text-left ml-2 align-self-center overflow-hidden"
                  >
                    <p
                      class=" bold-text text-truncate cp"
                      :style="{
                        color: '#0F1734',
                        'font-weight': '700',
                        'font-size': '20px',
                        'line-height': '30px',
                        'margin-bottom': '4.5px'
                      }"
                      @click="viewProfile(people)"
                    >
                      {{ people.display_name }}
                    </p>
                    <p
                      :style="{
                        color: '#94A3B8',
                        'font-weight': '700',
                        'font-size': '14px',
                        'line-height': '21px'
                      }"
                      v-if="people.location && people.location[0].state"
                      class="m-0 doc-loc text-truncate"
                    >
                      <img
                        src="../../assets/images/addphy-location.png"
                        :style="{
                          marginBottom: '3px',
                          paddingRight: '6.5px'
                        }"
                        alt="location icon"
                      />
                      {{ people.location[0].city }},
                      {{ people.location[0].state }}
                    </p>
                    <p
                      :style="{
                        color: '#0F1734',
                        'font-size': '14px',
                        'line-height': '21px',
                        'font-weight': 'bold',
                        'margin-top': '4.5px'
                      }"
                    >
                      {{ people.circle_member }} circle members
                    </p>
                  </div>

                  <div class="meet-others">
                    <a-button
                      :style="{
                        background: getPrimaryColor(),
                        'pointer-events': 'all',
                        'font-size': '14px',
                        'border-radius': '6px',
                        padding: '12px 24px'
                      }"
                      :loading="
                        loadingbtn === people.id && loadingrole === people.role
                      "
                      class=" font-white primary-button profile-btn view-profile"
                      @click="viewProfile(people)"
                    >
                      <!-- {{ people.on_circle ? "In your circle" : "ADD TO CIRCLE" }} -->
                      View Profile
                    </a-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center cp" v-if="!loading && !peopleList">
          No Results Found
        </div>
        <div v-if="!loading && count > limit && peopleList" class="d-flex justify-content-center mb-3">
          <a-pagination
            v-model="currentPage"
            class="dovemed-custom-pagination"
            :total="parseInt(count)"
            show-less-items
            :pageSize="limit"
            @change="getPeople"
          />
        </div>
      </div>
      <div v-if="loading" class="d-flex justify-content-center mt-3">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">
          Loading...
        </div>
      </div>
    </div>

    <MeetOthersSearchFilterModal
      ref="MeetOthersSearchFilterModal"
      :handleAnswer="handleAnswer"
      :clearfilter="clear"
    />
  </div>
</template>

<script>
import InviteOthersModal from "../../components/Modals/InviteOthersModal.vue";
import MeetOthersSearchFilterModal from "../../components/Modals/MeetOthersSearchFilterModal.vue";
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import User from "../../store/modules/User";
const UserRepository = RepositoryFactory.get("user");
const AppRepository = RepositoryFactory.get("app");
export default {
  name: "MeetOthers",
  data() {
    return {
      loading: false,
      loadingbtn: null,
      loadingrole: null,
      showFilters: false,
      hideFiltersToggle: false,
      searchLocation: undefined,
      searchGender: undefined,
      searchUserName: undefined,
      searchAge: undefined,
      ibs: undefined,
      peopleList: [],
      currentPage: 1,
      limit: 10,
      count: 0,
      sortKey: "Newest",
      clear: false
    };
  },
  components: {
    InviteOthersModal,
    MeetOthersSearchFilterModal
  },

  mounted() {
    this.setVariablesFromQuery();
    this.updateColor();
    this.$route.query.currentPage = 1;
    this.getPeople(this.currentPage);
    this.getIBS();
   
  },
  updated() {
    this.updateColor();
    
  },
  watch: {
    "$route.query.currentPage": {
      handler() {
        if (this.$route.query.currentPage === undefined) {
          this.currentPage = 1;
          this.clear = true;
          this.searchGender = undefined;
          this.searchUserName = "";
          this.searchLocation = undefined;
          this.searchAge = undefined;
          this.ibs = undefined;
          this.getPeople();
        }
      }
    },
    searchGender: {
      handler() {
        this.handlePathQuery("searchGender");
      }
    },
    searchAge: {
      handler() {
        this.handlePathQuery("searchAge");
      }
    },
    ibs: {
      handler() {
        this.handlePathQuery("ibs");
      }
    },
    sortKey: {
      handler() {
        this.handlePathQuery("sortKey");
      }
    },
    currentPage: {
      handler() {
        this.handlePathQuery("currentPage");
      }
    }
  },

  methods: {
    setVariablesFromQuery() {
      Object.keys(this.$route.query).forEach(key => {
        if (this.$route.query[key]) {
          this[key] = this.$route.query[key];
        }
      });
    },
    handlePathQuery(v) {
      this.$router
        .replace({
          ...this.$route,
          query: {
            ...this.$route.query,
            [v]: this[v]
          }
        })
        .catch(e => {});
    },
    updateColor() {
      const currentCircle = JSON.parse(localStorage.getItem("currentCircle"));
      this.$el.querySelectorAll(".dovemed-button").forEach(elem => {
        if (elem.classList.contains("router-link-active")) {
          elem.setAttribute(
            "style",
            ` background: ${currentCircle.color_code} !important; color: #fff !important; `
          );
        } else {
          if (!elem.classList.contains("router-link-active")) {
            if (elem.hasAttribute("style")) {
            
              elem.setAttribute(
                "style",
                ` background: ${currentCircle.color_code} !important; color: #fff !important; `
              );
            }
          }
        }
      });
    },
    handleAnswer(gender = undefined, age = undefined, ibs = undefined) {
      this.searchLocation = this.searchLocation;
      this.searchGender = gender;
      this.searchAge = age;
      this.ibs = ibs;
      this.currentPage = 1;
      this.clear = false;
      this.getPeople(this.currentPage);
    },
    getIBS() {
      this.$store.dispatch("Circle/diseaseTypes", {
        type: this.currentCircle.id
      });
    },
    clearFilters() {
     
      this.currentPage = 1;
      this.clear = true;
      this.searchGender = undefined;
      this.searchUserName = "";
      // this.searchLocation = "";
      this.searchAge = undefined;
      this.ibs = undefined;
      this.getPeople();
    },

    clearFilterType(type) {
      if (type === "ibs") {
        this.ibs = undefined;
      }
      if (type === "gender") {
        this.searchGender = undefined;
      }
      if (type === "age") {
        this.searchAge = undefined;
      }
      this.getPeople();
    },
    goToNext() {
      this.currentPage = this.currentPage + 1;
      this.getPeople(this.currentPage);
    },

    handlefilterModal() {
      this.$refs.MeetOthersSearchFilterModal.show({gender: this.searchGender, age: this.searchAge, ibs: this.ibs});
    },
    handleSearchLocation() {
      this.currentPage = 1;
      this.getPeople();
    },
    handleSearchChange(e) {
      this.searchLocation = e.target.value;
    },
    callDebounce: _.debounce(function() {
      this.currentPage = 1;
      this.getPeople();
    }, 500),
    viewProfile(user) {
      this.loadingbtn = user.id;
      this.loadingrole = user.role;
      if (user.id === this.authUser.user.id && user.role === this.authUser.user.role) {
        this.routeToAuthProfile(this.authUser.user.role);
        this.loadingbtn = false;
        this.loadingrole = false;
      } else {
        this.$store.commit("User/setViewUser", {data: {... this.viewUser, isDirectory: false}})
        this.loadingbtn = false;
        this.loadingrole = false;
        switch (user.role) {
          case "doctor":
            this.$router
              .push({
                name: "ViewDoctorUpdates",
                params: { id: user.id }
              })
              .catch(() => {});
            break;
          case "patient":
            this.$router
              .push({
                name: "ViewPatientUpdates",
                params: { id: user.id }
              })
              .catch(() => {});
            break;
          case "caregiver":
            this.$router
              .push({
                name: "ViewPatientUpdates",
                params: { id: user.id, role: 'caregiver' }
              })
              .catch(() => {});
            break;
          case "advocate":
            this.$router
              .push({
                name: "ViewAdvocateUpdates",
                params: { id: user.id }
              })
              .catch(() => {});
            break;
          default:
            break;
        }
      }
      
    },
    
    getPeople(page) {
      this.loading = true;
      this.handlePathQuery("searchLocation");
      const params = {};
      if (this.searchLocation) params.location = this.searchLocation.trim();
      if (this.searchGender) params.gender = this.searchGender;
      if (this.searchUserName) params.username = this.searchUserName;
      if (this.searchAge) params.age = this.searchAge;
      if (this.ibs) params.disease_type = this.ibs;

      

      AppRepository.memberSearch(
        page ? page : this.currentPage,
        this.limit,
        this.currentCircle.id,
        this.sortKey,
        params
      )
        .then(res => {
          if (res.data.data) {
            this.loading = false;
            this.peopleList = res.data.data.data;
            this.count = res.data.data.paginator.total_count;
            this.currentPage = Number(res.data.data.paginator.page_num);
            this.showFilters = true;
          } else {
            this.peopleList = [];
          }
        })
        .catch(err => {
          this.loading = false;
        
        });
    },
    sortList(key) {
      this.sortKey = key;
      this.currentPage = 1;
      this.getPeople();
    },
    handleClearSearch() {
      this.searchLocation = "";
      this.currentPage = 1;
      this.getPeople();
    }
  }
};
</script>

<style lang="scss" scoped>
.active-filter-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  align-self: flex-start;
  margin-top: 18px;
  margin-left: 5px;
  @media screen and (min-width: 701px) {
    top: 0;
    right: 0;
    position: absolute;
    margin-right: 10px;
    margin-top: 15px;
  }
}
@media screen and (max-width: 427px) {
  .clear-filter {
    display: none !important;
  }
  .apply {
    margin-bottom: 0px !important;
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #0f1734 !important;
    display: block !important;
  }
  .search-button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
  }
  .search-container {
    flex-direction: column;
  }
}

.filter-container2 {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  padding-top: 20px;
}
.filter-text {
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #0f1734;
  margin-left: 16px;
  @media screen and (min-width: 701px) {
    display: none;
  }
}
.appliedFilter {
  font-weight: 700;
  font-size: 14px;
  color: #647490;
  line-height: 24px;
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.filterTypeBox {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  gap: 8px;
  background: #f1f5f9;
  border-radius: 6px;

  .filterTypeText {
    font-weight: 700;
    font-size: 14px;
    color: #0f1734;
  }
}
.apply {
  display: none;
}
.meet-all {
  width: 100%;
  max-width: 400px;
  margin: auto;
  display: flex;
  justify-content: center;
  button {
    width: 50% !important;
    margin: 0;
  }
}
.filter-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.searchContainer {
  background-color: #f1f5f9 !important;
  border-radius: 8px !important;
  border: none !important;

  input {
    border: none !important;
  }
}

.card-section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 56px;
}
.search-field {
  background: #f1f5f9;
  border-radius: 8px;
  border: none;
  margin-right: 24px;
  height: 60px;
}
.search-button {
  width: 51px;
  background: #f1f5f9;
  border: none;
}
.sort-text {
  font-weight: 400;
  font-size: 14px;
  color: #0f1734;
  margin-bottom: 0px;
  cursor: context-menu;
}

.dovemed-card {
  .meet-all {
    .dovemed-button-left {
      font-weight: bold;
      border-top-left-radius: 15 !important;
      border-bottom-left-radius: 15 !important;
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }
    .dovemed-button-right {
      font-weight: bold;
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
      border-top-right-radius: 15 !important;
      border-bottom-right-radius: 15 !important;
    }
  }
}
.search-container {
  display: flex;
  margin-top: 24px;
  gap: 24px;

  .search-input-state {
    background: none;
    border-left: 0 !important;
    height: 60px;
    outline: none;
    font-weight: 400;
    font-size: 16px;
    line-height: 32px;

    &:focus {
      outline: none;
    }
  }

  .search-button {
    max-width: 60px;
    min-width: 60px;
    border-radius: 8px;
    height: 60px;
    &:focus {
      outline: none;
    }
  }
}

.dovemed-button {
  padding: 12px 45px;
}

// STYLES MEETPEOPLE
.meet-others {
  display: flex;
  align-items: center;
  button {
    display: flex;
    margin-right: 24px;
    font-size: 14px;
    border-radius: 6px;
    padding: 12px 24px;
    width: 126px;
    height: 48px;
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
  }
  span {
    font-size: 14px !important;
  }
}
.results {
  font-size: 20px;
  color: #0f1734;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
}
.search-field {
  background: #f1f5f9;
  border-radius: 8px;
  border: none;
  margin-right: 24px;
}
.signup-page {
  padding: 70px;
}
.divider {
  height: 159px;
  border: 1px solid #cbd5e1;
  margin-top: -16px;
  background: #cbd5e1;
  margin-left: 35.5px;
}
.search-container {
  display: flex;

  .search-input {
    padding: 10px;
    border-radius: 8px 0 0 8px;
    width: 95%;

    &:focus {
      outline: none;
    }
  }
  display: flex;
  align-items: center;
  .search-input-state {
    border-left: 0 !important;
    padding: 10px;
    width: 320px;
    @media screen and (max-width: 427px) {
      padding-left: 0px !important;
    }
    &:focus {
      outline: none;
    }
  }
  .dropdownOptions {
    margin-right: 154px;
  }

  .search-button {
    max-width: 100px;
    padding: 11px;

    @media screen and (max-width: 900px) {
      padding: 6px;
    }
    @media screen and (max-width: 769px) {
      max-width: 100%;
      width: 100%;
    }

    &:focus {
      outline: none;
    }
  }
}

.input-placeholder {
  min-width: unset;

  &.male {
    border-radius: 20px 0 0 20px;
  }

  &.female {
    border-radius: 0 0 0 0;
    margin-left: -5px;
  }
  &.other {
    border-radius: 0 20px 20px 0;
    margin-left: -5px;
  }
}

.claim-card {
  border: 1px solid #e2e8f0;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  .user-name {
    height: 159px;
    .bg-img {
      position: relative;
      // border: 1px solid #ccc;
      // min-width: 100px;
      max-width: 100px;
      min-height: 100px;
      max-height: 100px;
      border-radius: 50%;
      display: inline-block;
      margin-top: 24px;
      margin-left: 35.5px;

      .rating-badge {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 20%);
        font-size: 15px;
        border-radius: 20px;
        width: 55%;
      }
    }
  }

  .user-address {
    line-height: 15px;
  }

  .dovemed-card-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.125);

    span {
      font-size: 12px;
    }
  }
}

.claim-modal-header {
  border-radius: 5px 5px 0 0;
  min-height: 100px;
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;

  .profile-img {
    min-width: 150px;
    max-width: 150px;
    min-height: 150px;
    max-height: 150px;
    display: block;
    border-radius: 50%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 50%);
    box-shadow: 0px 5px 7px 0px rgba(0, 0, 0, 0.4);
  }
}

// .profile-details {
//   padding-top: 170px;
//   max-width: 60%;
//   margin: auto;
// }

// .terms-modal-container {
//   padding: 30px;
//   text-align: center;
// }

.background-image {
  background-position: center !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
}

.filters-cont {
  transition: height 0.3s ease-in-out;
}

.transparent {
  opacity: 0;
  display: none;
}

.no-results-container {
  background: rgb(246, 246, 246);
  padding: 20px;
  border-radius: 8px;
}
@media screen and (max-width: 581px) {
  .search-input-state {
    width: 100%;
  }
  .filters-cont {
    .filter-content {
      display: flex;
      flex-direction: column;
    }
    .input-placeholder {
      padding: 8px 8px;
    }
  }
}
.clear-filter {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  text-decoration-line: underline;
  margin-top: 24px;
  margin-right: 28px;
}
.right-items {
  display: flex;
  width: 100%;
  justify-content: space-between;
  overflow: none !important;
  margin-left: 24px;
  span {
    font-size: 14px !important;
  }

  @media screen and (max-width: 900px) {
    display: block;
  }

  @media screen and (max-width: 600px) {
    display: block;
  }
}

@media screen and (max-width: 769px) {
  .right-items {
    p {
      margin-bottom: 1rem !important;
      margin-top: 0px !important;
    }
  }
  .meet-others {
    .view-profile {
      width: 209px !important;
      justify-content: center !important;
    }
  }
  .claim-card .user-name .bg-img {
    margin-left: 0px !important;
  }
  .divider {
    margin-left: 16px !important;
  }
  .claim-card .user-name {
    height: 213px !important;
  }
  .dovemed-card {
    padding: 0px !important;
    box-shadow: none !important;
  }

  .divider {
    height: inherit !important;
  }
  
}
</style>

<style lang="scss">
.dovemed-custom-pagination .ant-pagination-item-active {
  background: #2a71d4;
}

.dovemed-custom-pagination .ant-pagination-item-active a {
  color: #ffffff !important ;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
}

.dovemed-custom-pagination .ant-pagination-item-active a:hover {
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/MeetOthers.vue